// extracted by mini-css-extract-plugin
export default {"labelsRow":"labels_labelsRow__RQdIk","labelChip":"labels_labelChip__zHqEp","labelModal":"labels_labelModal__8bi3T"};